import { type PropsWithChildren } from "react";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router";

import { SettingsProvider as IqfSettingsProvider } from "iqf-web-ui/settings";

import { deriveUdzsSorting } from "udzs-common/utils";

import { Link } from "@/components/link";
import { preserveCaseReturnTo } from "@/modules/case/utils/return-to";

export function SettingsProvider({ children }: PropsWithChildren) {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  return (
    <IqfSettingsProvider
      router={{
        Link,
        navigate: (href) => {
          if (href) {
            navigate(preserveCaseReturnTo(href, location));
          }
        },
        pathname: location.pathname,
        searchParams,
        useParams,
      }}
      zod={{
        enableQueryLogging: true,
      }}
      table={{ deriveSorting: deriveUdzsSorting }}
    >
      {children}
    </IqfSettingsProvider>
  );
}
